function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M38.2502 44.2499C36.3065 44.2535 34.4 43.7175 32.7429 42.7016C31.0859 41.6857 29.7433 40.2298 28.8648 38.496C27.9862 36.7622 27.6061 34.8186 27.7669 32.8816C27.9276 30.9445 28.6229 29.0902 29.7752 27.5249C28.5717 28.4275 27.5762 29.5782 26.8562 30.899C26.1361 32.2199 25.7083 33.68 25.6016 35.1806C25.495 36.6811 25.712 38.1871 26.2381 39.5965C26.7641 41.0059 27.5868 42.2858 28.6506 43.3495C29.7143 44.4133 30.9942 45.236 32.4036 45.762C33.813 46.2881 35.319 46.5051 36.8195 46.3985C38.3201 46.2918 39.7802 45.864 41.1011 45.1439C42.4219 44.4239 43.5726 43.4284 44.4752 42.2249C42.6714 43.5508 40.4888 44.2608 38.2502 44.2499V44.2499Z",
  fill: "#000064"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.925 30.7499C24.45 29.9999 24 28.5749 24 27.7499V26.2499C25.4897 24.8292 26.5323 23.0046 27 20.9999C28.875 20.9999 30 18.7499 30 16.4999C30 15.8999 30 13.4999 28.5 13.4999C32.25 2.62495 21.3 -1.50005 13.5 3.74995C10.2 3.74995 9.3 8.69995 10.5 13.4999C9 13.4999 9 15.8999 9 16.4999C9 18.7499 10.125 20.9999 12 20.9999C12.4464 23.0129 13.4924 24.8434 15 26.2499V27.7499C15 28.9499 14.625 30.4499 8.55 31.6499C2.475 32.8499 1.5 38.2499 1.5 38.2499H25.725C25.1676 35.688 25.5961 33.0101 26.925 30.7499V30.7499Z",
  fill: "#A5D0EC"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  d: "M25.725 38.25C25.1676 35.688 25.5961 33.0101 26.925 30.75L26.55 30.6C23.175 31.8 22.05 34.65 21.3 38.25H25.8H25.725ZM15 21C15.6 23.25 18.075 24.975 19.5 26.25V27.75C19.5 28.95 19.125 30.45 13.05 31.65C6.975 32.85 6 38.25 6 38.25H1.5C1.5 38.25 1.5 33 8.55 31.65C15.6 30.3 15 28.95 15 27.75V26.25C13.4924 24.8434 12.4464 23.013 12 21C10.125 21 9 18.75 9 16.5C9 15.9 9 13.5 10.5 13.5C9.3 8.69998 10.2 3.74998 13.5 3.74998C14.853 2.81309 16.3774 2.15202 17.986 1.80456C19.5946 1.4571 21.2559 1.43006 22.875 1.72498C21.1314 2.06878 19.474 2.75723 18 3.74998C14.7 3.74998 12.3 8.69998 13.5 13.5C13.5 13.5 13.5 19.5 15 21Z",
  fill: "#000064"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.925 30.7502C24.45 30.0002 24 28.5752 24 27.7502V26.2502C25.4897 24.8295 26.5323 23.0049 27 21.0002C28.875 21.0002 30 18.7502 30 16.5002C30 15.9002 30 13.5002 28.5 13.5002C32.25 2.62519 21.3 -1.49981 13.5 3.75019C10.2 3.75019 9.3 8.70019 10.5 13.5002C9 13.5002 9 15.9002 9 16.5002C9 18.7502 10.125 21.0002 12 21.0002C12.4718 23.0033 13.5138 24.8268 15 26.2502V27.7502C15 28.9502 14.625 30.4502 8.55 31.6502C2.475 32.8502 1.5 38.2502 1.5 38.2502H25.725L26.925 30.7502Z",
  stroke: "#48568B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M36 46.5C41.799 46.5 46.5 41.799 46.5 36C46.5 30.201 41.799 25.5 36 25.5C30.201 25.5 25.5 30.201 25.5 36C25.5 41.799 30.201 46.5 36 46.5Z",
  fill: "#E3FFE4"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M36 46.5C41.799 46.5 46.5 41.799 46.5 36C46.5 30.201 41.799 25.5 36 25.5C30.201 25.5 25.5 30.201 25.5 36C25.5 41.799 30.201 46.5 36 46.5Z",
  stroke: "#48568B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M40.5 33L35.25 39L32.25 36",
  stroke: "#48568B",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgUserChecked = function SvgUserChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/userChecked.7d195218.svg";
export { ForwardRef as ReactComponent };